import type { SVGProps } from "react";
export interface GithubIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function GithubIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: GithubIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M1.727 15.909a1.125 1.125 0 0 1 1.33.709l.034.11.1.34c.554 1.667 1.989 2.807 3.713 2.807H10l.116.006a1.125 1.125 0 0 1 0 2.239l-.116.005H6.904c-2.813 0-5.023-1.873-5.849-4.349l-.146-.503-.022-.113a1.125 1.125 0 0 1 .84-1.251"
      />
      <path
        fill={color}
        d="M15.875 22v-2.73c0-.7-.302-1.306-.708-2.32v-.001a1.513 1.513 0 0 1 1.405-2.075l.441-.022a4.303 4.303 0 0 0 3.861-4.28c0-1.284-.298-2.49-.958-3.466l-.136-.191a1.61 1.61 0 0 1-.152-1.686l.129-.304a2.8 2.8 0 0 0 .016-1.75 3.32 3.32 0 0 0-1.776.918 1.637 1.637 0 0 1-1.329.479l-.178-.026c-1.104-.22-2.034-.423-2.99-.423-.717 0-1.42.113-2.193.263l-.798.16a1.7 1.7 0 0 1-.785-.026 1.7 1.7 0 0 1-.72-.427 3.32 3.32 0 0 0-1.778-.918c-.213.701-.17 1.418.147 2.054a1.61 1.61 0 0 1-.03 1.495l-.122.19c-.756 1.007-1.096 2.288-1.096 3.658a4.3 4.3 0 0 0 4.302 4.303c1.07 0 1.802 1.08 1.405 2.074v.001c-.405 1.014-.708 1.62-.708 2.32V22a1.125 1.125 0 0 1-2.25 0v-2.73c0-.816.24-1.585.491-2.232a6.55 6.55 0 0 1-5.49-6.466c0-1.607.371-3.272 1.324-4.696-.57-1.412-.427-2.937.223-4.236l.1-.169A1.39 1.39 0 0 1 6.66.875l.278.007a5.54 5.54 0 0 1 3.416 1.398c.956-.193 2.03-.407 3.145-.407s2.188.215 3.144.408A5.54 5.54 0 0 1 20.338.875l.194.013c.38.054.725.264.946.583l.1.169.125.268c.541 1.238.628 2.651.096 3.967.954 1.424 1.325 3.089 1.325 4.697a6.55 6.55 0 0 1-5.491 6.466c.25.648.492 1.416.492 2.232V22a1.125 1.125 0 0 1-2.25 0"
      />
    </svg>
  );
}
